import { render, staticRenderFns } from "./MailAIAssistant.vue?vue&type=template&id=ab86f7dc&scoped=true"
import script from "./MailAIAssistant.vue?vue&type=script&lang=js"
export * from "./MailAIAssistant.vue?vue&type=script&lang=js"
import style0 from "./MailAIAssistant.vue?vue&type=style&index=0&id=ab86f7dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab86f7dc",
  null
  
)

export default component.exports